import { get, omit } from "lodash";

export const initialState = {
  tracks: [],
  tracksLoaded: false,
  tracksWithId: {}
};

const userFavoritesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER_FAVORITE_TRACKS": {
      return {
        ...state,
        tracks: action.payload.favoriteTracks,
        tracksLoaded: true
      };
    }
    case "CLEAR_USER_FAVORITE_TRACKS": {
      return { ...state, tracks: [], tracksWithId: {}, tracksLoaded: false };
    }
    case "SET_FAVORITE_TRACK": {
      const trackCode = get(action, "payload.trackCode");
      const favoriteId = get(action, "payload.favoriteId");
      const index = Object.keys(get(state, "tracksWithId", [])).indexOf(
        get(action, "payload.trackCode", "")
      );
      if (index === -1) {
        return {
          ...state,
          tracks: [...state.tracks, action.payload.trackCode],
          tracksWithId: {
            ...state.tracksWithId,
            [trackCode]: favoriteId
          }
        };
      }
      return { ...state, tracks: [...state.tracks, action.payload.trackCode] };
    }
    case "SET_USER_FAVORITE_TRACKS_WITH_FAVORITE_ID": {
      return { ...state, tracksWithId: action.payload.favoriteTracksWithId };
    }
    case "REMOVE_FAVORITE_TRACK": {
      return {
        ...state,
        tracks: [...state.tracks.filter((t) => t !== action.payload.trackCode)],
        tracksWithId: omit(state.tracksWithId, action.payload.trackCode)
      };
    }
    default: {
      return state;
    }
  }
};

export default userFavoritesReducer;
